import {getAPIGatewayDataFromParent} from "../handler/ParentDataHandler";

const NFMS_PROCESS_NAME = "nfms";

/**
 * NFMS API client that routes through Boson API Gateway bridge.
 *
 */
export async function nfmsPost(operation, requestBody) {
    try {
        const response = await getAPIGatewayDataFromParent({
            resourcePath: `/${operation}`,
            httpMethod: "post",
            processName: NFMS_PROCESS_NAME,
            requestBody: requestBody
        });
        const result = response || {status: 0, data: {}};

        if (result.status !== 200) {
            throw result;
        }
        return result;
    } catch (exception) {
        console.error(`[NFMS] Error calling ${operation}:`, exception);
        throw exception;
    }
}



// WEBPACK FOOTER //
// ./src/handler/NfmsClient.js